import { Component, Input, Output,EventEmitter, HostListener } from '@angular/core';
import { LibService } from '../service/lib.service';
import'pdfjs-dist/build/pdf.combined';
import'pdfjs-dist/web/pdf_viewer';

declare let PDFJS: any;
export class LibComponent {

    
    urlFile: string;

    
    blobFile: Blob;

    
    nameFile: string;

    
    showToolbar: boolean = true;

    currentPdfDocument: any;
    page: number;
    displayPage: number;
    totalPages: number;
    laodingPercent: number;
    pdfViewer: any;
    currentScaleMode: string = 'auto';
    currentScale: number;

    MAX_AUTO_SCALE: number = 0.75;
    DEFAULT_SCALE_DELTA: number = 1.1;
    MIN_SCALE: number = 0.25;
    MAX_SCALE: number = 10.0;

    //Custom Changes
     showContentChanged = new EventEmitter<boolean>();
    _showContent: boolean = false;
private _canPrint: boolean = true;
     downloadContent = new EventEmitter<boolean>();
/**
 * @return {?}
 */
get showContent() {
        return this._showContent;
    }
/**
 * @param {?} value
 * @return {?}
 */
set showContent(value: boolean) {
        this._showContent = value;
    }
/**
 * @return {?}
 */
get canPrint() {
        return this._canPrint;
    }
/**
 * @param {?} value
 * @return {?}
 */
set canPrint(value: boolean) {
        this._canPrint = value;
    }
/**
 * @return {?}
 */
closePdf() {
        this._showContent = false;
        this.showContentChanged.emit(false);
    }
/**
 * @return {?}
 */
printPdf() {
        const /** @type {?} */ iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = this.urlFile;
        document.body.appendChild(iframe);
        //iframe.contentWindow.print();
    }
/**
 * @return {?}
 */
downloadPdf() {
        this.downloadContent.emit(true);
    }
/**
 * @param {?} renderingQueueServices
 */
constructor(private renderingQueueServices: LibService) {
    }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes) {
        if (!this.urlFile && !this.blobFile) {
            throw new Error('Attribute urlFile or blobFile is required');
        }

        if (this.urlFile) {
            return new Promise((resolve, reject) => {
                this.executePdf(this.urlFile, resolve, reject);
            });
        } else {
            return new Promise((resolve, reject) => {
                let /** @type {?} */ reader = new FileReader();
                reader.onload = () => {
                    this.executePdf(reader.result, resolve, reject);
                };
                reader.readAsArrayBuffer(this.blobFile);
            });
        }
    }
/**
 * @param {?} src
 * @param {?} resolve
 * @param {?} reject
 * @return {?}
 */
executePdf(src, resolve, reject) {
        let /** @type {?} */ loadingTask = this.getPDFJS().getDocument(src);

        loadingTask.onProgress = (progressData) => {
            let /** @type {?} */ level = progressData.loaded / progressData.total;
            this.laodingPercent = Math.round(level * 100);
        };

        loadingTask.then((pdfDocument) => {
            this.currentPdfDocument = pdfDocument;
            this.totalPages = pdfDocument.numPages;
            this.page = 1;
            this.displayPage = 1;
            this.initPDFViewer(this.currentPdfDocument);

            this.currentPdfDocument.getPage(1).then(() => {
                this.scalePage('auto');
                resolve();
            }, (error) => {
                reject(error);
            });

        }, (error) => {
            reject(error);
        });
    }
/**
 * return the PDFJS global object (exist to facilitate the mock of PDFJS in the test)
 * 
 * @return {?}
 */
getPDFJS() {
        return PDFJS;
    }
/**
 * @param {?} pdfDocument
 * @return {?}
 */
initPDFViewer(pdfDocument: any) {
        PDFJS.verbosity = 1;
        PDFJS.disableWorker = false;

        let /** @type {?} */ documentContainer = document.getElementById('viewer-pdf-container');
        let /** @type {?} */ viewer: any = document.getElementById('viewer-viewerPdf');

        window.document.addEventListener('scroll', (event) => {
            this.watchScroll(event.target);
        }, true);

        this.pdfViewer = new PDFJS.PDFViewer({
            container: documentContainer,
            viewer: viewer,
            renderingQueue: this.renderingQueueServices
        });

        this.renderingQueueServices.setViewer(this.pdfViewer);

        this.pdfViewer.setDocument(pdfDocument);
    }
/**
 * Method to scale the page current support implementation
 * 
 * @param {?} scaleMode
 * @return {?}
 */
scalePage(scaleMode) {
        this.currentScaleMode = scaleMode;
        if (this.pdfViewer) {

            let /** @type {?} */ viewerContainer = document.getElementById('viewer-main-container');
            let /** @type {?} */ documentContainer = document.getElementById('viewer-pdf-container');

            let /** @type {?} */ widthContainer;
            let /** @type {?} */ heigthContainer;

            if (viewerContainer && viewerContainer.clientWidth <= documentContainer.clientWidth) {
                widthContainer = viewerContainer.clientWidth;
                heigthContainer = viewerContainer.clientHeight;
            } else {
                widthContainer = documentContainer.clientWidth;
                heigthContainer = documentContainer.clientHeight;
            }

            let /** @type {?} */ currentPage = this.pdfViewer._pages[this.pdfViewer._currentPageNumber-1];

            let /** @type {?} */ padding = 20;
            let /** @type {?} */ pageWidthScale = (widthContainer - padding) / currentPage.width * currentPage.scale;
            let /** @type {?} */ pageHeightScale = (heigthContainer - padding) / currentPage.width * currentPage.scale;

            let /** @type {?} */ scale;

            switch (this.currentScaleMode) {
                case 'page-actual':
                    scale = 1;
                    break;
                case 'page-width':
                    scale = pageWidthScale;
                    break;
                case 'page-height':
                    scale = pageHeightScale;
                    break;
                case 'page-fit':
                    scale = Math.min(pageWidthScale, pageHeightScale);
                    break;
                case 'auto':
                    let /** @type {?} */ horizontalScale;
                    if (this.isLandscape) {
                        horizontalScale = Math.min(pageHeightScale, pageWidthScale);
                    } else {
                        horizontalScale = pageWidthScale;
                    }
                    scale = Math.max(this.MAX_AUTO_SCALE, horizontalScale);

                    break;
                default:
                    //this.logService.error('pdfViewSetScale: \'' + scaleMode + '\' is an unknown zoom value.');
                    return;
            }
            this.setScaleUpdatePages(scale);
        }
    }
/**
 * Update all the pages with the newScale scale
 * 
 * @param {?} newScale
 * @return {?}
 */
setScaleUpdatePages(newScale: number) {
        if (!this.isSameScale(this.currentScale, newScale)) {
            this.currentScale = newScale;

            this.pdfViewer._pages.forEach(function (currentPage) {
                currentPage.update(newScale);
            });

            this.pdfViewer.update();
        }
    }
/**
 * method to check if the request scale of the page is the same for avoid unuseful re-rendering
 * 
 * @param {?} oldScale - old scale page
 * @param {?} newScale - new scale page
 * 
 * @return {?} boolean
 */
isSameScale(oldScale: number, newScale: number) {
        return (newScale === oldScale);
    }
/**
 * method to check if is a land scape view
 * 
 * @param {?} width
 * @param {?} height 
 * 
 * @return {?} boolean
 */
isLandscape(width: number, height: number) {
        return (width > height);
    }
/**
 * Method triggered when the page is resized
 * @return {?}
 */
onResize() {
        this.scalePage(this.currentScaleMode);
    }
/**
 * toggle the fit page pdf
 * @return {?}
 */
pageFit() {
        if (this.currentScaleMode !== 'page-fit') {
            this.scalePage('page-fit');
        } else {
            this.scalePage('auto');
        }
    }
/**
 * zoom in page pdf
 * 
 * @param {?} ticks
 * @return {?}
 */
zoomIn(ticks: number) {
        let /** @type {?} */ newScale: any = this.currentScale;
        do {
            newScale = (newScale * this.DEFAULT_SCALE_DELTA).toFixed(2);
            newScale = Math.ceil(newScale * 10) / 10;
            newScale = Math.min(this.MAX_SCALE, newScale);
        } while (--ticks > 0 && newScale < this.MAX_SCALE);
        this.currentScaleMode = 'auto';
        this.setScaleUpdatePages(newScale);
    }
/**
 * zoom out page pdf
 * 
 * @param {?} ticks
 * @return {?}
 */
zoomOut(ticks: number) {
        let /** @type {?} */ newScale: any = this.currentScale;
        do {
            newScale = (newScale / this.DEFAULT_SCALE_DELTA).toFixed(2);
            newScale = Math.floor(newScale * 10) / 10;
            newScale = Math.max(this.MIN_SCALE, newScale);
        } while (--ticks > 0 && newScale > this.MIN_SCALE);
        this.currentScaleMode = 'auto';
        this.setScaleUpdatePages(newScale);
    }
/**
 * load the previous page
 * @return {?}
 */
previousPage() {
        if (this.pdfViewer && this.page > 1) {
            this.page--;
            this.displayPage = this.page;

            this.pdfViewer.currentPageNumber = this.page;
        }
    }
/**
 * load the next page
 * @return {?}
 */
nextPage() {
        if (this.pdfViewer && this.page < this.totalPages) {
            this.page++;
            this.displayPage = this.page;

            this.pdfViewer.currentPageNumber = this.page;
        }
    }
/**
 * load the page in input
 * 
 * @param {?} page
 * @return {?}
 */
inputPage(page: string) {
        let /** @type {?} */ pageInput = parseInt(page, 10);

        if (!isNaN(pageInput) && pageInput > 0 && pageInput <= this.totalPages) {
            this.page = pageInput;
            this.displayPage = this.page;
            this.pdfViewer.currentPageNumber = this.page;
        } else {
            this.displayPage = this.page;
        }
    }
/**
 * Litener Scroll Event
 * 
 * @param {?} target
 * @return {?}
 */
watchScroll(target) {
        let /** @type {?} */ outputPage = this.getVisibleElement(target);

        if (outputPage) {
            this.page = outputPage.id;
            this.displayPage = this.page;
        }
    }
/**
 * find out what elements are visible within a scroll pane
 * 
 * @param {?} target
 * @return {?}
 */
getVisibleElement(target) {
        return this.pdfViewer._pages.find((page) => {
            return this.isOnScreen(page, target);
        });
    }
/**
 * check if a page is visible
 * 
 * @param {?} page
 * @param {?} target
 * @return {?}
 */
isOnScreen(page: any, target: any) {
        let /** @type {?} */ viewport: any = {};
        viewport.top = target.scrollTop;
        viewport.bottom = viewport.top + target.scrollHeight;
        let /** @type {?} */ bounds: any = {};
        bounds.top = page.div.offsetTop;
        bounds.bottom = bounds.top + page.viewport.height;
        return ((bounds.top <= viewport.bottom) && (bounds.bottom >= viewport.top));
    };
/**
 * Litener Keyboard Event
 * @param {?} event
 * @return {?}
 */
handleKeyboardEvent(event: KeyboardEvent) {
        let /** @type {?} */ key = event.keyCode;
        if (key === 39) { // right arrow
            this.nextPage();
        } else if (key === 37) {// left arrow
            this.previousPage();
        }
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'pdf-viewer',
    template: `

      <div class="mainDiv" *ngIf="_showContent">
        <!-- Start Pdf Canvas -->
        <div id="viewer-pdf-container" class="viewer-pdf-container" (keypress)=eventHandler() (window:resize)="onResize($event)">
            <div id="viewer-viewerPdf" class="pdfViewer">
                <div id="loader-container" class="loader-container">
                    <div class="loader-item">
                        <div id="loader-spin" class="mdl-progress mdl-js-progress mdl-progress__indeterminate"></div>
                        <div id="loader-text" class="loader-text">Loading <span>{{nameFile}}</span> {{laodingPercent}}%</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Pdf Canvas -->
        <!-- Close Section -->
        <div class="pdf-btn-row">

            <div id="viewer-toolbar-view-options">
                <button (click)="downloadPdf()" class="close-pdf" *ngIf="_canPrint">
                    <!--<i class="icon material-icons" id="viewer-close-button">&#xE2C4;</i>-->
                    <i class="material-icons">&#xE8AD;</i>
                </button>
                <button class="close-pdf" (click)="closePdf()">
                    <i class="icon material-icons" id="viewer-close-button">close</i>
                </button>
          
            </div>
            <!-- End Close Section -->
            <!-- Pagination toolbar start -->
            <div *ngIf="showToolbar" id="viewer-toolbar-pagination" class="viewer-toolbar-pagination mdl-cell--hide-tablet mdl-cell--hide-phone">
                <div id="viewer-previous-page-button" aria-label="arrow left" class="button-page left" (click)="previousPage()">
                    <i class="icon material-icons">keyboard_arrow_left</i>
                </div>

                <div class="viewer-page-counter left">
                    <input id="viewer-pagenumber-input" #page
                           (keyup.enter)="inputPage(page.value)" class="viewer-pagenumber-input left" type="text" pattern="-?[0-9]*(\\.[0-9]+)?" value="{{displayPage}}">
                    <div id="viewer-total-pages" class="left viewer-total-pages">/ {{totalPages}}</div>
                </div>

                <div id="viewer-next-page-button" aria-label="arrow right" class="button-page left" (click)="nextPage()">
                    <i class="icon material-icons">keyboard_arrow_right</i>
                </div>
            </div>
            <!-- Pagination toolbar end -->
            <!-- Command toolbar start -->
            <div *ngIf="showToolbar" id="viewer-toolbar-command" class="viewer-toolbar-command">
                <div id="viewer-scale-page-button" aria-label="zoom out map" class="button-page left" (click)="pageFit()">
                    <i class="icon material-icons">zoom_out_map</i>
                </div>
                <div id="viewer-zoom-in-button" aria-label="zoom in" class="button-page left" (click)="zoomIn()">
                    <i class="icon material-icons">zoom_in</i>
                </div>
                <div id="viewer-zoom-out-button" aria-label="zoom out" class="button-page left" (click)="zoomOut()">
                    <i class="icon material-icons">zoom_out</i>
                </div>
            </div>
            <!-- Command toolbar end -->

        </div>
      </div>
    `,
    styles: [`
      .loader-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex-direction:row;-moz-box-flex-direction:row;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:100%}.loader-item{margin:auto;max-height:100px;max-width:300px}.loader-text{white-space:nowrap;text-align:center;position:relative;color:#fff}.left{float:left}.pdfViewer-container{position:fixed;top:0;left:0;width:100%;height:100%;z-index:1}.pdf-btn-row{position:fixed;width:100%;top:20px;left:0;z-index:2}.close-pdf{background:none;color:#fff;border:0}.viewer-toolbar-pagination{padding-top:4px;top:80px;right:35px;width:auto;position:absolute;border-radius:10px;background:#3e3e3e;color:#fff}.mainDiv{color:rgba(0,0,0,.87)}#viewer-toolbar-view-options{padding-top:3px 5px;top:30px;right:35px;width:auto;position:absolute;border-radius:5px;background:#3e3e3e}.viewer-toolbar-command{height:30px;padding-top:4px;top:80px;left:35px;width:auto;position:absolute;border-radius:10px;background:#3e3e3e;color:#fff}.viewer-pagenumber-input{border:none;display:block;background:0 0;width:33px}.viewer-pagenumber-input,.viewer-total-pages{font-size:16px;padding:4px 0;text-align:right;color:inherit;margin-right:4px;height:20px}.viewer-total-pages{border:medium none;display:-webkit-box;display:-ms-flexbox;display:flex;background:transparent none repeat scroll 0 0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.viewer-page-counter{margin-right:20px}.button-page{margin-right:4px;height:24px;width:24px;margin-left:4px;cursor:pointer}.button-page:hover{cursor:pointer;background:grey;border-radius:24px}:host>>>.textLayer{position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;opacity:.2;line-height:1}:host>>>.textLayer>div{color:transparent;position:absolute;white-space:pre;cursor:text;-webkit-transform-origin:0 0;transform-origin:0 0}:host>>>.textLayer .highlight{margin:-1px;padding:1px;background-color:#b400aa;border-radius:4px}:host>>>.textLayer .highlight.begin{border-radius:4px 0 0 4px}:host>>>.textLayer .highlight.end{border-radius:0 4px 4px 0}:host>>>.textLayer .highlight.middle{border-radius:0}:host>>>.textLayer .highlight.selected{background-color:#006400}:host>>>.textLayer ::selection{background:#00f}:host>>>.textLayer ::-moz-selection{background:#00f}:host>>>.textLayer .endOfContent{display:block;position:absolute;left:0;top:100%;right:0;bottom:0;z-index:-1;cursor:default;-webkit-user-select:none;-ms-user-select:none;-moz-user-select:none}:host>>>.textLayer .endOfContent.active{top:0}:host>>>.annotationLayer section{position:absolute}:host>>>.annotationLayer .linkAnnotation>a{position:absolute;font-size:1em;top:0;left:0;width:100%;height:100%;background:url("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7") 0 0 repeat}:host>>>.annotationLayer .linkAnnotation>a:hover{opacity:.2;background:#ff0;-webkit-box-shadow:0 2px 10px #ff0;box-shadow:0 2px 10px #ff0}:host>>>.annotationLayer .textAnnotation img{position:absolute;cursor:pointer}:host>>>.annotationLayer .popupWrapper{position:absolute;width:20em}:host>>>.annotationLayer .popup{position:absolute;z-index:200;max-width:20em;background-color:#ff9;-webkit-box-shadow:0 2px 5px #333;box-shadow:0 2px 5px #333;border-radius:2px;padding:.6em;margin-left:5px;cursor:pointer;word-wrap:break-word}:host>>>.annotationLayer .popup h1{font-size:1em;border-bottom:1px solid #000;padding-bottom:.2em}:host>>>.annotationLayer .popup p{padding-top:.2em}.annotationLayer .fileAttachmentAnnotation,.annotationLayer .squigglyAnnotation,.annotationLayer .strikeoutAnnotation,.annotationLayer .underlineAnnotation,:host>>>.annotationLayer .highlightAnnotation{cursor:pointer}:host>>>.pdfViewer .canvasWrapper{overflow:hidden}:host>>>.pdfViewer .page{direction:ltr;width:816px;height:1056px;margin:1px auto -8px;position:relative;overflow:visible;border:9px solid transparent;background-clip:content-box;background-color:#fff}:host>>>.pdfViewer.removePageBorders .page{margin:0 auto 10px;border:none}:host>>>.pdfViewer .page canvas{margin:0;display:block}:host>>>.pdfViewer .page .loadingIcon{position:absolute;display:block;left:0;top:0;right:0;bottom:0}:host>>>.loadingIcon{width:100px;height:100px;left:50%!important;top:50%!important;margin-top:-50px;margin-left:-50px;font-size:5px;text-indent:-9999em;border-top:1.1em solid rgba(3,0,2,.2);border-right:1.1em solid rgba(3,0,2,.2);border-bottom:1.1em solid rgba(3,0,2,.2);border-left:1.1em solid #030002;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation:a 1.1s infinite linear;animation:a 1.1s infinite linear}:host>>>.loadingIcon,:host>>>.loadingIcon:after{border-radius:50%}@-webkit-keyframes a{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes a{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}:host>>>*{padding:0;margin:0}:host>>>html{height:100%;width:100%;font-size:10px}:host>>>body{height:100%;width:100%;background-color:#404040}:host>>>body,button,input,select{font:message-box;outline:none}:host>>>.hidden,:host>>>[hidden]{display:none!important}#viewer-pdf-container{overflow:auto;-webkit-overflow-scrolling:touch;position:absolute;top:0;right:0;bottom:0;left:0;outline:none;background:#555;z-index:9999}html[dir=ltr] #viewer-pdf-container{-webkit-box-shadow:inset 1px 0 0 hsla(0,0%,100%,.05);box-shadow:inset 1px 0 0 hsla(0,0%,100%,.05)}html[dir=rtl] #viewer-pdf-container{-webkit-box-shadow:inset -1px 0 0 hsla(0,0%,100%,.05);box-shadow:inset -1px 0 0 hsla(0,0%,100%,.05)}
    `],
    providers: [LibService]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: LibService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'urlFile': [{ type: Input },],
'blobFile': [{ type: Input },],
'nameFile': [{ type: Input },],
'showToolbar': [{ type: Input },],
'showContentChanged': [{ type: Output },],
'downloadContent': [{ type: Output },],
'showContent': [{ type: Input },],
'canPrint': [{ type: Input },],
'handleKeyboardEvent': [{ type: HostListener, args: ['document:keydown', ['$event'], ] },],
};
}

function LibComponent_tsickle_Closure_declarations() {
/** @type {?} */
LibComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LibComponent.ctorParameters;
/** @type {?} */
LibComponent.propDecorators;
/** @type {?} */
LibComponent.prototype.urlFile;
/** @type {?} */
LibComponent.prototype.blobFile;
/** @type {?} */
LibComponent.prototype.nameFile;
/** @type {?} */
LibComponent.prototype.showToolbar;
/** @type {?} */
LibComponent.prototype.currentPdfDocument;
/** @type {?} */
LibComponent.prototype.page;
/** @type {?} */
LibComponent.prototype.displayPage;
/** @type {?} */
LibComponent.prototype.totalPages;
/** @type {?} */
LibComponent.prototype.laodingPercent;
/** @type {?} */
LibComponent.prototype.pdfViewer;
/** @type {?} */
LibComponent.prototype.currentScaleMode;
/** @type {?} */
LibComponent.prototype.currentScale;
/** @type {?} */
LibComponent.prototype.MAX_AUTO_SCALE;
/** @type {?} */
LibComponent.prototype.DEFAULT_SCALE_DELTA;
/** @type {?} */
LibComponent.prototype.MIN_SCALE;
/** @type {?} */
LibComponent.prototype.MAX_SCALE;
/** @type {?} */
LibComponent.prototype.showContentChanged;
/** @type {?} */
LibComponent.prototype._showContent;
/** @type {?} */
LibComponent.prototype._canPrint;
/** @type {?} */
LibComponent.prototype.downloadContent;
/** @type {?} */
LibComponent.prototype.renderingQueueServices;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
